module.exports = __webpack_public_path__ + "static/LOGO 1-5f71b0ad8584a302fc3fe253033d89f9.png";